@if (!authPage()) {
<div class="topbar">
  <div class="wrap">
    <div class="links">
      <a href="#stores">{{ 'top.stores' | translate }}</a>
      <span class="sep">|</span>
      <a href="#policy">{{ 'top.policy' | translate }}</a>
      <span class="sep">|</span>
      <span>{{ 'top.connect' | translate }}</span>
      <a href="#facebook" aria-label="Facebook"><span class="material-symbols-outlined" style="font-size:18px">thumb_up</span></a>
      <a href="#instagram" aria-label="Instagram"><span class="material-symbols-outlined" style="font-size:18px">photo_camera</span></a>
    </div>
    <div class="links">
      <!-- TEMP HIDDEN: Notifications feature not supported yet, hidden from users
      <a role="button" tabindex="0" (click)="toast.notSupported('header.notifyFeature')">
        <span class="material-symbols-outlined" style="font-size:16px;vertical-align:-3px">notifications</span> {{ 'top.notify' | translate }}
      </a>
      -->
      <a href="#support"><span class="material-symbols-outlined" style="font-size:16px;vertical-align:-3px">help</span> {{ 'top.support' | translate }}</a>
      @if (auth.isAuthenticated()) {
        <a routerLink="/account">{{ auth.displayName() }}</a>
        <span class="sep">|</span>
        <a role="button" tabindex="0" (click)="auth.logout()">{{ 'common.logout' | translate }}</a>
      } @else {
        <a routerLink="/auth" [queryParams]="{ mode: 'register' }">{{ 'top.register' | translate }}</a>
        <span class="sep">|</span>
        <a routerLink="/auth">{{ 'top.login' | translate }}</a>
      }
    </div>
  </div>
</div>

<header class="header">
  <div class="wrap">
    <a routerLink="/" class="logo" aria-label="Unified Ecommerce">Unified<b>.</b></a>
    <form class="search" (ngSubmit)="search()">
      <input
        type="search"
        [ngModel]="searchTerm()"
        (ngModelChange)="searchTerm.set($event)"
        name="search"
        [placeholder]="'search.placeholder' | translate"
        [attr.aria-label]="'header.searchAria' | translate"
      />
      <button type="submit" [attr.aria-label]="'search.button' | translate">
        <span class="material-symbols-outlined">search</span>
      </button>
    </form>
    <div class="icons">
      <div class="langsw" aria-label="Language">
        <button type="button" [class.on]="language.current() === 'vi'" (click)="language.use('vi')">VI</button>
        <button type="button" [class.on]="language.current() === 'en'" (click)="language.use('en')">EN</button>
      </div>
      <!-- TEMP HIDDEN: Wishlist feature not supported yet, hidden from users
      <button
        type="button"
        class="ico-btn hide-mobile"
        [attr.aria-label]="'header.wishlist' | translate"
        [title]="'header.wishlist' | translate"
        (click)="toast.notSupported('header.wishlistFeature')"
      >
        <span class="material-symbols-outlined">favorite</span>
      </button>
      -->
      <!--
        Guest (current): order-lookup entrypoint, shown with an "order" icon so it reads as
        order lookup. Once customer login exists, the authenticated branch becomes the
        account/user entrypoint (person icon); no sales flow is gated by this, it is display-only.
      -->
      @if (auth.isAuthenticated()) {
        <a routerLink="/account" class="ico-btn" [attr.aria-label]="'header.account' | translate" [title]="'header.account' | translate">
          <span class="material-symbols-outlined">person</span>
        </a>
      } @else {
        <a routerLink="/track" class="ico-btn" [attr.aria-label]="'header.track' | translate" [title]="'header.track' | translate">
          <span class="material-symbols-outlined">receipt_long</span>
        </a>
      }
      <a routerLink="/cart" class="ico-btn" [attr.aria-label]="'header.cart' | translate" [title]="'header.cart' | translate">
        <span class="material-symbols-outlined">shopping_cart</span>
        @if (cart.count() > 0) {
          <span class="count">{{ cart.count() }}</span>
        }
      </a>
      <button
        type="button"
        class="ico-btn menu-toggle"
        [attr.aria-label]="'header.openMenu' | translate"
        [attr.aria-expanded]="menuOpen()"
        (click)="menuOpen.set(true)"
      >
        <span class="material-symbols-outlined">menu</span>
      </button>
    </div>
  </div>
</header>

@if (categories().length) {
  <nav class="catstrip" [attr.aria-label]="'header.categoriesAria' | translate">
    <div class="wrap">
      <button type="button" class="cat-arrow prev" [attr.aria-label]="'header.categoriesPrev' | translate" (click)="scrollCats(-320)">
        <span class="material-symbols-outlined">chevron_left</span>
      </button>
      <div class="cat-scroll no-scrollbar" #catScroll>
        @for (category of categories(); track category.id) {
          <a
            [routerLink]="['/c', category.slug]"
            [queryParams]="{ categoryId: category.id, categoryName: category.name }"
          >
            {{ category.name }}
          </a>
        }
      </div>
      <button type="button" class="cat-arrow next" [attr.aria-label]="'header.categoriesNext' | translate" (click)="scrollCats(320)">
        <span class="material-symbols-outlined">chevron_right</span>
      </button>
    </div>
  </nav>
}

<!-- Mobile navigation drawer: the phone home for everything the hidden top bar/search row can't
     hold — account/login, order tracking, primary links, categories and the language switch. -->
@if (menuOpen()) {
  <div class="drawer-root">
    <div class="drawer-backdrop" (click)="closeMenu()"></div>
    <aside class="drawer" role="dialog" aria-modal="true" [attr.aria-label]="'header.menu' | translate">
      <div class="drawer-head">
        <span class="logo">Unified<b>.</b></span>
        <button type="button" class="ico-btn" [attr.aria-label]="'header.closeMenu' | translate" (click)="closeMenu()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="drawer-body">
        @if (auth.isAuthenticated()) {
          <div class="drawer-account">
            <span class="material-symbols-outlined">account_circle</span>
            <div>
              <strong>{{ 'header.greeting' | translate: { name: auth.displayName() } }}</strong>
              <a routerLink="/account">{{ 'header.account' | translate }}</a>
            </div>
          </div>
          <button type="button" class="btn btn-ghost btn-block" (click)="auth.logout(); closeMenu()">
            {{ 'common.logout' | translate }}
          </button>
        } @else {
          <div class="drawer-auth">
            <a routerLink="/auth" class="btn btn-primary btn-block">{{ 'top.login' | translate }}</a>
            <a routerLink="/auth" [queryParams]="{ mode: 'register' }" class="btn btn-outline btn-block">
              {{ 'top.register' | translate }}
            </a>
          </div>
        }

        <nav class="drawer-links">
          <a routerLink="/track"><span class="material-symbols-outlined">receipt_long</span>{{ 'header.track' | translate }}</a>
          <a routerLink="/products"><span class="material-symbols-outlined">grid_view</span>{{ 'header.allProducts' | translate }}</a>
          <a href="#stores" (click)="closeMenu()"><span class="material-symbols-outlined">store</span>{{ 'top.stores' | translate }}</a>
          <a href="#support" (click)="closeMenu()"><span class="material-symbols-outlined">help</span>{{ 'top.support' | translate }}</a>
        </nav>

        @if (categories().length) {
          <div class="drawer-section">
            <h3>{{ 'header.categoriesTitle' | translate }}</h3>
            <nav class="drawer-cats">
              @for (category of categories(); track category.id) {
                <a
                  [routerLink]="['/c', category.slug]"
                  [queryParams]="{ categoryId: category.id, categoryName: category.name }"
                >
                  {{ category.name }}
                </a>
              }
            </nav>
          </div>
        }

        <div class="drawer-lang" aria-label="Language">
          <button type="button" [class.on]="language.current() === 'vi'" (click)="language.use('vi')">VI</button>
          <button type="button" [class.on]="language.current() === 'en'" (click)="language.use('en')">EN</button>
        </div>
      </div>
    </aside>
  </div>
}
}

<router-outlet />

@if (!authPage()) {
<footer class="footer" id="support">
  <div class="wrap">
    <div class="cols">
      <div>
        <div class="brand">Unified<b>.</b></div>
        <p style="max-width:280px;font-size:14px">{{ 'footer.about' | translate }}</p>
        <div class="flex gap-12 mt-16">
          <a href="#public" class="ico-btn" style="color:#fff"><span class="material-symbols-outlined">public</span></a>
          <a href="#mail" class="ico-btn" style="color:#fff"><span class="material-symbols-outlined">mail</span></a>
          <a href="#call" class="ico-btn" style="color:#fff"><span class="material-symbols-outlined">call</span></a>
        </div>
      </div>
      <div>
        <h4>{{ 'footer.service' | translate }}</h4>
        <a href="#support">{{ 'footer.help' | translate }}</a>
        <a href="#returns">{{ 'footer.returns' | translate }}</a>
        <a href="#guide">{{ 'footer.guide' | translate }}</a>
        <a routerLink="/track">{{ 'header.track' | translate }}</a>
      </div>
      <div>
        <h4>{{ 'footer.company' | translate }}</h4>
        <a href="#about">{{ 'footer.story' | translate }}</a>
        <a href="#careers">{{ 'footer.careers' | translate }}</a>
        <a href="#stores">{{ 'top.stores' | translate }}</a>
        <a href="#news">{{ 'footer.news' | translate }}</a>
      </div>
      <div>
        <h4>{{ 'footer.legal' | translate }}</h4>
        <a href="#terms">{{ 'footer.terms' | translate }}</a>
        <a id="policy" href="#privacy">{{ 'footer.privacy' | translate }}</a>
        <a href="#shipping">{{ 'footer.shippingPolicy' | translate }}</a>
        <a href="#contact">{{ 'footer.contact' | translate }}</a>
      </div>
    </div>
    <div class="bottom">
      <span>{{ 'footer.copyright' | translate }}</span>
      <span>{{ 'footer.secure' | translate }}</span>
    </div>
  </div>
</footer>
}

@if (toast.message(); as msg) {
  <div class="toast" role="status">
    <span class="material-symbols-outlined">info</span>
    {{ msg }}
  </div>
}

@if (!authPage()) {
  <app-compare-bar />
  @if (compare.count() > 0) {
    <div class="compare-bar-spacer" aria-hidden="true"></div>
  }
  <app-chat-widget />
}
